import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPackageIn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPackageIn"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V11H19.5V4.5H16V10H8V4.5H4.5V19.5H13V21H3V3ZM17.8107 13.75L16.3107 15.25H19.25C20.7688 15.25 22 16.4812 22 18V21H20.5V18C20.5 17.3096 19.9404 16.75 19.25 16.75H16.3107L17.8107 18.25L16.75 19.3107L13.4393 16L16.75 12.6893L17.8107 13.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPackageIn;
